import { gql } from '@apollo/client';

const GET_ONE_QUESTION = gql`
  query GetOneQuestion($questionId: ID!) {
    question(questionId: $questionId) {
      id
      publicId
      title
      priority
      resolutionStatus
      assignedTopics {
        id
        name
      }
      description
      isAnswered
      answersCount
      createdBy {
        id
        firstName
        lastName
        email
        pictureURL
      }
      resources {
        id
        name
        type
        mimeType
      }
      owners {
        id
        email
        firstName
        lastName
        pictureURL
      }
      groups {
        id
        name
        color
      }
      createdAt
      updatedAt
      hasConfirmedAnswer
      duplicateQuestionIds
      duplicates {
        id
        publicId
        title
        answersCount
        createdAt
        latestAnswer {
          id
          description
          resources {
            id
            name
            type
            mimeType
          }
        }
      }
    }
  }
`;

export default GET_ONE_QUESTION;
